module.exports = __webpack_public_path__ + "static/media/chicargos-A5-flyer.76007e29.jpeg";